module.exports = __webpack_public_path__ + "static/media/pa.bd9d5e26.svg";